import { __rest, __assign } from 'tslib';
import * as React from 'react';
import { classNames, useUitkContext } from 'uitk-react-utils';
import styles from './uitk-text.css';
import { UitkTypeAlignments, UitkTypeMargins, UitkTypeOverflows, UitkTypeHyphens, UitkTypeSizes, UitkTypeWeights, UitkTypeWhiteSpaces, UitkTextThemes } from './types.esm.js';
var getClassNameList = classNames.bind(styles);
/**
 * Use for freestanding text elements that are not a list, paragraph, or heading.
 * Should not replace the usage of lists or headings.
 */
var UitkText = function (props) {
  var align = props.align,
    children = props.children,
    inline = props.inline,
    passedInSize = props.size,
    spacing = props.spacing,
    overflow = props.overflow,
    weight = props.weight,
    whiteSpace = props.whiteSpace,
    className = props.className,
    _a = props.theme,
    theme = _a === void 0 ? 'default' : _a,
    _b = props.wordBreak,
    wordBreak = _b === void 0 ? false : _b,
    dataTestId = props.dataTestId,
    hyphens = props.hyphens,
    attributes = __rest(props, ["align", "children", "inline", "size", "spacing", "overflow", "weight", "whiteSpace", "className", "theme", "wordBreak", "dataTestId", "hyphens"]);
  var isPhraseTag = inline && typeof inline === 'string';
  var size = !isPhraseTag && !passedInSize ? 300 : passedInSize;
  var Tag;
  if (inline && typeof inline === 'boolean') {
    Tag = 'span';
  } else if (isPhraseTag) {
    Tag = inline;
  } else {
    Tag = 'div';
  }
  var contextData = useUitkContext().data;
  var _c = contextData !== null && contextData !== void 0 ? contextData : {},
    bottomScrimContext = _c.bottomScrimContext,
    overlayScrimContext = _c.overlayScrimContext,
    contextClassNames = _c.contextClassNames;
  var wrapperClassNames = getClassNameList('uitk-text', align && UitkTypeAlignments.get(align), spacing && UitkTypeMargins.get(spacing), overflow && !inline && UitkTypeOverflows.get(overflow), wordBreak && !inline && UitkTypeOverflows.get('wrap'), hyphens && UitkTypeHyphens.get(hyphens), !bottomScrimContext && size && UitkTypeSizes.get(size), !bottomScrimContext && weight && UitkTypeWeights.get(weight), whiteSpace && UitkTypeWhiteSpaces.get(whiteSpace), bottomScrimContext && "in-bottom-scrim", overlayScrimContext && "in-overlay-scrim", !(bottomScrimContext || overlayScrimContext) && theme && UitkTextThemes.get(theme), contextClassNames === null || contextClassNames === void 0 ? void 0 : contextClassNames.UitkText, className);
  return children ? React.createElement(Tag, __assign({
    className: wrapperClassNames
  }, dataTestId ? {
    'data-test-id': dataTestId
  } : {}, attributes), children) : null;
};
UitkText.displayName = 'UitkText';
export { UitkText };